var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":_vm.scoreColor,"size":"24"}},[_c('v-icon',{attrs:{"dark":"","size":"medium"}},[_vm._v(" "+_vm._s(_vm.scoreIcon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }